//@ts-nocheck
import { usePhases } from "@/state/cacheStoreHooks";
import { RoomVariant } from "@/types/game";
import { StrapiMedia } from "@/components/shared/StrapiMedia";

type Props = {
    onSelect?: (phaseId: string, roomVariant: RoomVariant) => void;
};

const RoomItemCheckerRoomSelect = ({ onSelect }: Props) => {
    const phases = usePhases();

    return (
        <div className="flex size-full flex-col items-center justify-center gap-8 p-4 text-gray-900">
            {phases.map((phase) => (
                <div key={phase.documentId} className="border p-4 rounded-lg w-full max-w-md">
                    <h2 className="text-xl font-semibold mb-2">Variants {phase.name || phase.documentId}</h2>
                    <div className="flex gap-4">
                        {phase.room_a && (
                            <button
                                className="cursor-pointer h-30 w-1/2"
                                onClick={() => onSelect(phase.documentId, "a")}
                            >
                                <StrapiMedia
                                    size="lg"
                                    image={phase.room_a.image}
                                    alt={phase.room_a.name}
                                    className="h-full w-full object-contain"
                                />
                            </button>
                        )}
                        {phase.room_b && (
                            <button
                                className="cursor-pointer h-30 w-1/2"
                                onClick={() => onSelect(phase.documentId, "b")}
                            >
                                <StrapiMedia
                                    size="lg"
                                    image={phase.room_b.image}
                                    alt={phase.room_b.name}
                                    className="h-full w-full object-contain"
                                />
                            </button>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RoomItemCheckerRoomSelect;
